let transformConfig: TransformConfig = {
    maxScale: 4,
    minScale: 0.1,
    scale: 1,
    x: 0,
    y: 0,
    speed: 0.1
};

export default transformConfig;
